import { adminFetch } from "./_client";


export function pinNote(token: string, scope: "user" | "trip" | "car", noteId: number, pinned = true) {
  return adminFetch<{ note: Record<string, unknown> }>(`/admin/notes/${scope}/${noteId}/pin`, token, {
    method: "POST",
    body: JSON.stringify({ pinned }),
  });
}

export function editNote(token: string, scope: "user" | "trip" | "car", noteId: number, body: { note: string; mentions?: string[] }) {
  return adminFetch<{ note: Record<string, unknown> }>(`/admin/notes/${scope}/${noteId}`, token, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}
